<template>
  <div class="checkinNum">
    <div>NO: {{ 報到號碼 }}</div>
    <div v-if="withTime">建議報到時間: {{ person.建議時間 }}</div>
  </div>
</template>

<script>
export default {
  props: ["person", "withTime"],
  computed: {
    報到號碼() {
      return _.padStart(this.person.報到號碼, 4, "0");
    },
  },
};
</script>

<style scoped lang="scss">
.checkinNum {
  position: absolute;
  left: 20px;
  top: 12px;
  z-index: 99999;
}
</style>
